<template>
    <div style="width: 100%;">
        <van-swipe :autoplay="3000" style="width: 100%;">
            <van-swipe-item v-for="(image, index) in images" :key="index">
              <img :src="image" style="width: 100%;display:block;"/>
            </van-swipe-item>
          </van-swipe>
    </div>

</template>


<script>
    import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';
import { Lazyload } from 'vant';
Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
export default{
  props:['tb'],
    data() {
    return {
      images: [

      ],
    };
  },
  created(){
    if(this.tb)
  this.images = this.tb.map(item=>item.data);  
   
  },
  watch:{
    tb(){
      if(this.tb)
  this.images = this.tb.map(item=>item.data);   
    }
  }
}
</script>


<style>

</style>


// WEBPACK FOOTER //
// src/fields/Swiper.vue